module.exports = __webpack_public_path__ + "media/packs/images/transit/pod-3f3eefd7f5c451f1d1e97015aae5d3b1.svg";